import { GroupsView } from '../../../../components/worldcup/GroupsView/GroupsView';

export default function WorldCupGroupsRoute() {
  return <GroupsView />;
}
